
import FolderAdd from "../../../assets/duotone/FolderAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderAddIcon({ className, dataTestid = "FolderAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FolderAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
